/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".callout_48a4edb6 .ms-Suggestions-itemButton{padding:0;border:none}.callout_48a4edb6 .ms-Suggestions{min-width:300px}" }]);
export var callout = "callout_48a4edb6";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map